import { render, staticRenderFns } from "./Life.vue?vue&type=template&id=597f1cd4&scoped=true"
import script from "./Life.vue?vue&type=script&lang=js"
export * from "./Life.vue?vue&type=script&lang=js"
import style0 from "./Life.vue?vue&type=style&index=0&id=597f1cd4&prod&scoped=true&lang=css"
import style1 from "./Life.vue?vue&type=style&index=1&id=597f1cd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597f1cd4",
  null
  
)

export default component.exports